import { chartExamples } from "../../data/chartExamples.js";
import { state } from "../../state/workspaceStore.js";
import { nodes } from "../common/reactHelpers.jsx";
import { esc } from "../../utils/format.js";
export function salesChart(a) {
  a = {
    ...a,
    collections: chartExamples(state.db.collections),
  };
  const slot = 96,
    left = 58,
    top = 35,
    plot = 250,
    base = top + plot,
    width = left + a.collections.length * slot + 20,
    height = 395;
  return (
    <figure className={"collection-column-chart"}>
      <figcaption className={"hint"}>
        {"Demo sales share (%) \xB7 fixed illustrative values"}
      </figcaption>
      <div
        className={"chart-scroll"}
        tabIndex={"0"}
        role={"region"}
        aria-label={"Collection chart. Scroll horizontally on smaller screens."}
      >
        <svg
          className={"sales-columns"}
          viewBox={"0 0 " + width + " " + height}
          role={"img"}
          aria-label={"Collection sales share from 0 to 100 percent"}
        >
          <title>{"Collection Sales Analysis"}</title>
          <desc>
            {
              "Each column shows hard-coded demo percentages, not recorded sales. Focus a column for its percentage."
            }
          </desc>
          {nodes(
            [0, 25, 50, 75, 100].map((t) => {
              let y = base - (t / 100) * plot;
              return (
                <>
                  <line
                    className={"column-grid"}
                    x1={left}
                    y1={y}
                    x2={width - 20}
                    y2={y}
                  ></line>
                  <text
                    className={"axis-tick"}
                    x={left - 9}
                    y={y + 4}
                    textAnchor={"end"}
                  >
                    {t}
                    {"%"}
                  </text>
                </>
              );
            }),
          )}
          <path
            className={"column-axis"}
            d={"M" + left + " " + top + "V" + base + "H" + (width - 20)}
          ></path>
          <text
            className={"axis-title"}
            transform={"translate(14 " + (top + plot / 2) + ") rotate(-90)"}
            textAnchor={"middle"}
          >
            {"Sales share (%)"}
          </text>
          {nodes(
            a.collections.map((c, i) => {
              const percent = Math.max(
                  0,
                  Math.min(100, Number(c.percent) || 0),
                ),
                x = left + i * slot + slot / 2,
                h = (percent / 100) * plot,
                detail =
                  c.name + ": " + percent.toFixed(1) + "% · hard-coded demo";
              return (
                <g
                  className={"sales-column"}
                  tabIndex={"0"}
                  role={"img"}
                  aria-label={esc(detail)}
                >
                  <title>{esc(detail)}</title>
                  <rect
                    className={"column-hit"}
                    x={x - 42}
                    y={top}
                    width={"84"}
                    height={plot}
                  ></rect>
                  <rect
                    className={"column-fill"}
                    x={x - 23}
                    y={base - h}
                    width={"46"}
                    height={h}
                    rx={"2"}
                  ></rect>
                  {percent === 0 ? (
                    <line
                      className={"column-zero"}
                      x1={x - 23}
                      x2={x + 23}
                      y1={base}
                      y2={base}
                    ></line>
                  ) : (
                    ""
                  )}
                  <text
                    className={"column-value"}
                    x={x}
                    y={base - h - 9}
                    textAnchor={"middle"}
                  >
                    {percent.toFixed(1)}
                    {"%"}
                  </text>
                  <text
                    className={"column-name"}
                    transform={
                      "translate(" +
                      (x - 6) +
                      " " +
                      (base + 19) +
                      ") rotate(35)"
                    }
                  >
                    {esc(
                      c.name.length > 13 ? c.name.slice(0, 12) + "…" : c.name,
                    )}
                  </text>
                  <text
                    className={"column-detail"}
                    x={x}
                    y={top - 17}
                    textAnchor={"middle"}
                  >
                    {"Demo: "}
                    {percent.toFixed(1)}
                    {"%"}
                  </text>
                </g>
              );
            }),
          )}
          <text
            className={"axis-title"}
            x={(width + left) / 2}
            y={height - 8}
            textAnchor={"middle"}
          >
            {"Collections"}
          </text>
        </svg>
      </div>
      <p className={"hint"}>
        {
          "Hard-coded demo percentages for presentation only. Calendar filters update summary cards and Recent orders; these sample bars stay fixed. Additional collections show 0%."
        }
      </p>
    </figure>
  );
}
